import { Box, Button, Card, Typography } from '@mui/material';
import React from 'react';
import contactIcon from '../../../assets/User.png';
import cost from '../../../assets/cost.svg';
import msgIcon from '../../../assets/buttoniconnew.png';
import { useDispatch, useSelector } from 'react-redux';
import { messageSelector } from '../../utils/selectors/selectors';

const MessageSummary = ({ resetMsgSummary }) => {
   const selector = useSelector(messageSelector);
   // const dispatch = useDispatch();

   return (
      <Card sx={{ padding: '25px', minWidth: '400px' }}>
         <Typography
            sx={{
               textAlign: 'center',
               fontSize: {xs:'1rem', sm:'1.3rem' ,lg:'1.5rem'},
               fontWeight: 600,
               color: '#2E2C21',
               marginTop:{xs:'2rem', sm:'2.3rem' ,lg:'2.8rem'}
            }}
            className='font-cormorant'
         >

            Message Summary
         </Typography>
         <Box
            sx={{
               margin: '1rem auto',
               padding: '10px',
              
               width: 'max-content',
            }}
         >
            <Typography
               sx={{
                 
                  fontWeight: '400',
                  display: 'flex',
                  marginTop: '10px',
                  color:'#2E2C21'
               }}
            >
               <img
                  src={contactIcon}
                  alt="contact"
                  style={{ marginRight: '15px' }}
               />
               {`DND numbers: ${
                  selector.msgCost ? selector.msgCost.dNDCount : 0
               } contacts`}
            </Typography>
            <Typography
               sx={{
           
                  fontWeight: '400',
                  display: 'flex',
                  marginTop: '10px',
                  color:'#2E2C21'
               }}
            >
               <img
                  src={contactIcon}
                  alt="contact"
                  style={{ marginRight: '15px' }}
               />
               {`Non-DND numbers: ${
                  selector.msgCost ? selector.msgCost.nonDNDCount : 0
               } contacts`}
            </Typography>
            <Typography
               sx={{
               
                  fontWeight: '400',
                  display: 'flex',
                  marginTop: '10px',
                  color:'#2E2C21'
               }}
            >
               <img
                  src={msgIcon}
                  alt="contact"
                  style={{ marginRight: '15px' }}
               />
               {`Message Length: ${
                  selector.msgCost ? selector.msgCost.numberOfPages : 1
               } pages`}
            </Typography>
            <Typography
               sx={{
            
                  fontWeight: '400',
                  display: 'flex',
                  marginTop: '10px',
                  color:'#2E2C21'
               }}
            >
               <img src={cost} alt="contact" style={{ marginRight: '15px',marginLeft:'0.4rem' }} />
               {`Cost per page: ${
                  selector.msgCost
                     ? Math.ceil(selector.msgCost.totalCost) /
                       (selector.msgCost.numberOfPages > 0
                          ? selector.msgCost.numberOfPages
                          : 1)
                     : 0
               } SMS Unit`}
            </Typography>
         </Box>
         <Box>
            <Typography
               sx={{
           
                  textAlign: 'center',
                  color:'#0040BF',
                  fontWeight:'400'
               }}
            >
               You will be charged
            </Typography>
            <Typography
               sx={{
            
                  fontWeight: '600',
                  fontSize: {xs:'1.3rem', sm:'1.7', md:'2.2rem'}, 
                  textAlign: 'center',
                  color:"#0040BF"
               }}
            >
               {`${selector.msgCost ? selector.msgCost.totalCost : 0} `}  <span style={{fontSize:'0.8rem'}}> SMS Unit</span>   
            </Typography>
            <Typography
               sx={{
                
                  textAlign: 'center',
                   color:'#0040BF',
                  fontWeight:'400'
               }}
            >
               to send this message
            </Typography>
         </Box>
         <Box sx={{ margin: '1.5rem auto', width: '80%' }}>
            <Button
               variant="contained"
               sx={{
                  fontSize: '0.9rem',
                  width: '100%',
                  paddingTop: '5px',
                  paddingBottom: '5px',
                  background:'#0040BF'
               }}
               onClick={() => resetMsgSummary()}
            >
               Confirm
            </Button>
         </Box>
      </Card>
   );
};

export default MessageSummary;
